import { render, staticRenderFns } from "./english-question.vue?vue&type=template&id=f376116c&scoped=true&"
import script from "../../assets/js/exam/english-question.js?vue&type=script&lang=js&"
export * from "../../assets/js/exam/english-question.js?vue&type=script&lang=js&"
import style0 from "../../assets/css/exam.css?vue&type=style&index=0&id=f376116c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f376116c",
  null
  
)

export default component.exports